function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

function animateCount(el, to, suffix, duration) {
  const start = 0;
  let startTime = null;

  function tick(ts) {
    if (!startTime) startTime = ts;
    const progress = Math.min((ts - startTime) / duration, 1);
    const eased = easeOutCubic(progress);
    const current = Math.round(start + (to - start) * eased);
    el.textContent = current + (suffix || '');
    if (progress < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

function runCounters(root) {
  if (root.__countInited) return;
  const duration = parseInt(root.dataset.countDuration || '1200', 10);
  root.querySelectorAll('.js-count').forEach((el) => {
    const to = parseInt(el.getAttribute('data-target') || '0', 10);
    const suffix = el.getAttribute('data-suffix') || '';
    animateCount(el, to, suffix, duration);
  });
  root.__countInited = true;
}

function setupObserver(root) {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          runCounters(root);
          io.unobserve(root);
        }
      });
    },
    { threshold: 0.05 }
  );
  io.observe(root);

  const inEditor =
    document.documentElement.classList.contains('shopify-design-mode') ||
    window.Shopify?.designMode;

  if (inEditor) {
    runCounters(root);
    document.addEventListener('shopify:section:load', (e) => {
      if (e?.target?.contains(root)) runCounters(root);
    });
  }
}

export function initStatsCounters(scope = document) {
  scope.querySelectorAll('[data-stats-root]').forEach((root) => {
    if (!root.__observerAttached) {
      setupObserver(root);
      root.__observerAttached = true;
    }
  });
}
